import {
  UserOutlined,
  SafetyCertificateOutlined,
  ToolOutlined,
} from "@ant-design/icons";
import PropTypes from "prop-types";

const UserRoleIcon = ({ role }) => {
  if (role === "super") {
    return <SafetyCertificateOutlined />;
  }

  if (role === "admin") {
    return <ToolOutlined />;
  }

  if (role === "user") {
    return <UserOutlined />;
  }

  return <></>;
};

UserRoleIcon.propTypes = {
  role: PropTypes.string,
};

export default UserRoleIcon;
